// Used when /site-meta-data is unavailable (e.g. listing-only mode).
// Only spring_sale_2026 is seeded so it becomes the primary campaign.
export const campaignFallback = {
	spring_sale_2026: {
		start_date: '2026-10-19 00:00:00',
		end_date: '2026-11-15 23:59:59',
		promo: 'SPRING26',
	},
}
